import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../lib/api';

/**
 * Silent route tracker — POSTs to /api/activity/visit on every route change.
 * Debounced (100ms) so React StrictMode's double-render doesn't double-count.
 * Also generates a stable visitor_id in localStorage for anonymous visits.
 */
export default function RouteTracker() {
  const location = useLocation();
  const timer = useRef(null);
  const lastPath = useRef(null);

  useEffect(() => {
    if (lastPath.current === location.pathname + location.search) return;
    lastPath.current = location.pathname + location.search;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      try {
        let vid = localStorage.getItem('mandispot_visitor_id');
        if (!vid) {
          vid = `v-${Math.random().toString(36).slice(2, 10)}-${Date.now().toString(36)}`;
          localStorage.setItem('mandispot_visitor_id', vid);
        }
        analytics.logVisit(
          { path: location.pathname + location.search, referrer: document.referrer || null, title: document.title || null },
          vid,
        ).catch(() => {});
      } catch { /* best-effort — never break navigation */ }
    }, 100);
    return () => timer.current && clearTimeout(timer.current);
  }, [location.pathname, location.search]);

  return null;
}
